import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import classNames from 'classnames';
import {
  closePopovers,
  OverlayType,
  setOverlay,
  State,
} from 'app/gamma/src/modules';
import { isTeamBuilderExperiment } from 'app/gamma/src/selectors/create-menu';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { preloadData } from 'app/scripts/views/organization/InviteTeamMembers/TeamIllustrationAnimation';
import { TeamType } from 'app/gamma/src/modules/state/models/teams';
import { HomeTestIds } from '@trello/webdriverio-tests';
import {
  TabButtonProps,
  TabIcon,
  TabText
} from './tab';
import styles from './create-team-button.less';

import { forTemplate } from 'app/common/lib/util/i18n';
const l = forTemplate('home');

interface CreateTeamButtonProps {
  fullTab?: boolean;
}

type CreateTeamButtonStateProps = TabButtonProps & {
  inTeamBuilderExperiment: boolean;
};

type CreateTeamButtonDispatchProps = TabButtonProps & {
  onClickCreateItem?: () => void;
};

type AllProps = CreateTeamButtonProps &
                CreateTeamButtonStateProps &
                CreateTeamButtonDispatchProps;

const CreateTeamButtonUnconnected: React.FunctionComponent<AllProps> = ({
  inTeamBuilderExperiment,
  onClick,
  onClickCreateItem,
  fullTab,
  ...props
}) => {
  useEffect(() => {
    if (inTeamBuilderExperiment) {
      preloadData();
    }
  });

  return (
    <button
      className={classNames(
        styles.createTeamButton,
        {
          [styles.fullTab]: fullTab
        }
      )}
      data-test-id={HomeTestIds.NavigationCreateTeamButton}
      onClick={inTeamBuilderExperiment ? onClickCreateItem : onClick}
      aria-label={l('home-create-team')}
      {...props}
    >
      <TabIcon iconName="add" />
      {fullTab &&
       <TabText>{l('home-create-team')}</TabText>}
    </button>
  );
};

const mapStateToProps = (): CreateTeamButtonStateProps => {
  return {
    inTeamBuilderExperiment: isTeamBuilderExperiment(),
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch<State>,
): CreateTeamButtonDispatchProps => {
  return {
    onClickCreateItem() {
      trackUe({
        category: Noun.HOME,
        verb: Verb.OPENS,
        directObj: Noun.CREATE_TEAM_MODAL,
        method: 'by clicking create team in left sidebar',
      });

      dispatch(closePopovers());
      dispatch(
        setOverlay({
          overlayType: OverlayType.CreateTeam,
          teamType: TeamType.Default,
        }),
      );
    },
  };
};

export const CreateTeamButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateTeamButtonUnconnected);
